import React from 'react';

import {
  Control,
  Controller,
  FieldPath,
  FieldValues
} from 'react-hook-form';
import {
  Box,
  Button,
  styled
} from '@mui/material';

import { fields } from 'iron-forge-react-modules';



const RootBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  alignItems: 'center'
}));

const ImgContainerBox = styled(Box)({
  height: 256,
  width: 256,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

const ImgPreview = styled('img')({
  maxHeight: 256,
  maxWidth: 256
});


export interface IProps<TFormState extends FieldValues> {
  fieldKey: FieldPath<TFormState>;
  formControl: Control<TFormState>;
  disabled?: boolean;
  existingUrl: string;
}

export function genControllerComponent<TFormState extends FieldValues>() {
  const FieldFieldController: React.FC<IProps<TFormState>> = props => {
    return (
      <Controller
        control={props.formControl}
        name={props.fieldKey}
        render={({ field }) => (
          <fields.FileInputField.FC
            isDisabled={props.disabled}
            acceptTypes={['image/png', 'image/jpeg']}
            onSelectFile={field.onChange}>
            {handleClick => (
              <RootBox>
                <ImgContainerBox>
                  <ImgPreview src={field.value?.dataUrl || props.existingUrl} />
                </ImgContainerBox>

                <Button
                  disabled={props.disabled}
                  onClick={handleClick}>
                  Upload Logo
                </Button>
              </RootBox>
            )}
          </fields.FileInputField.FC>
        )}
      />
    );
  };

  return FieldFieldController;
}

